import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Table from "../../../../core/common/dataTable/index";
import { exam } from "../../../../core/data/json/exam";
import dayjs from "dayjs";
import { all_routes } from "../../../router/all_routes";
import { useUserPermissions } from "../../../UserPermissionsContext";
import Cookies from "js-cookie";
import { Button, Checkbox, CheckboxChangeEvent, Select, Spin } from "antd";
import { OverlayTrigger, Toast, Tooltip } from "react-bootstrap";

type Permission = { id: number; name: string };
type Admin = {
    id: number;
    username: string;
    hour: number;
    total_calls: number;
    connected_calls: number;
    total_conversation_duration: number;
    sales: number;
};

type Agent = {
    id: number;
    username: string;
};

const { Option } = Select;


const WizklubHourlyReport = () => {
    const routes = all_routes;
    const navigate = useNavigate();
    const data = exam;
    const dropdownMenuRef = useRef<HTMLDivElement | null>(null);
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0"); // Month is zero-based, so we add 1
    const day = String(today.getDate()).padStart(2, "0");
    const formattedDate = `${month}-${day}-${year}`;
    const defaultValue = dayjs(formattedDate);
    const jwtToken = Cookies.get("authToken");
    const { userPermissions, webApi } = useUserPermissions();
    const [isLoading, setIsLoading] = useState(false);
    const [totalPages, setTotalPages] = useState(0);
    const [permissions, setPermissions] = useState<Permission[]>([]);
    const [admin, setAdmin] = useState<Admin[]>([]);
    const [from, setFrom] = useState();
    const [to, setTo] = useState<number>();
    const [totalCount, setTotalCount] = useState();
    const [toastMessage, setToastMessage] = useState("");
    const [showSuccessToast, setShowSuccessToast] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState<number>(10);
    const [searchText, setSearchText] = useState<string>("");
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
    const [AsignshowCard, setAsignShowCard] = useState(false);
    const [selectedAgent, setSelectedAgent] = useState<string[]>([]);
    const [agentsLoading, setAgentsLoading] = useState(false);
    const [agentsDropdown, setAgentsDropdown] = useState<Agent[]>([]);
    const [dangerToastMessage, setDangerToastMessage] = useState("");
    const [showSolidDangerToast, setShowSolidDangerToast] = useState(false);
    const [showSolidSuccessToast, setshowSolidSuccessToast] = useState(false);
    const [startHour, setStartHour] = useState<any>(() =>
        JSON.parse(localStorage.getItem("wizklubStartHour") || "null")
    );

    const [endHour, setEndHour] = useState<any>(() =>
        JSON.parse(localStorage.getItem("wizklubEndHour") || "null")
    );

    const [teamType, setTeamType] = useState<any>(() =>
        JSON.parse(localStorage.getItem("wizklubTeamType") || "null")
    );


    const [targetDate, setTargetDate] = useState<string>(() =>
        JSON.parse(localStorage.getItem("wizklubTargetDate") || '""')
    );

    useEffect(() => {
        localStorage.setItem("wizklubTeamType", JSON.stringify(teamType));
    }, [teamType]);
    useEffect(() => {
        localStorage.setItem("wizklubStartHour", JSON.stringify(startHour));
    }, [startHour]);

    useEffect(() => {
        localStorage.setItem("wizklubEndHour", JSON.stringify(endHour));
    }, [endHour]);

    useEffect(() => {
        localStorage.setItem("wizklubTargetDate", JSON.stringify(targetDate));
    }, [targetDate]);
    const handleSolidDangerToastClose = () => setShowSolidDangerToast(false);
    const [startHour1, setStartHour1] = useState<number | "">("");
    const [endHour1, setEndHour1] = useState<number | "">("");
    const [targetDate1, setTargetDate1] = useState<string>("");

    let requestBody = {};
    if (startHour !== null && endHour !== null && targetDate && teamType) {
        requestBody = {
            start_time: startHour,
            end_time: endHour,
            target_date: targetDate,
            team_type: teamType,
        };
    }

    const checkPermission = (action: any, subject: any) => {
        return userPermissions.some(
            (ability) => ability.action === action && ability.subject === subject
        );
    };

    useEffect(() => {
        if (!checkPermission("can_view_hourly_call_report", "calllog")) {
            navigate(routes.crmLandingPage);
        } else {
            fetchData(currentPage, pageSize, searchText);
            // fetchAgentsData();
        }
    }, [userPermissions]);

    const handleApplyClick = () => {
        if (dropdownMenuRef.current) {
            dropdownMenuRef.current.classList.remove("show");
        }
    };

    const fetchAgentsData = async () => {
        setAgentsLoading(true);
        try {
            const response = await fetch(
                `${webApi}/teammgmt/get_team_members_by_teammgmt/2/`,
                options
            );
            const data = await response.json();
            setAgentsDropdown(data);
        } catch (error) {
            console.error("Failed to fetch agents", error);
        } finally {
            setAgentsLoading(false);
        }
    };

    const getModalContainer = () => {
        const modalElement = document.getElementById("modal-datepicker");
        return modalElement ? modalElement : document.body; // Fallback to document.body if modalElement is null
    };

    const options = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwtToken}`,
        },
    };

    const fetchGroupsData = async (
        page: number,
        pageSize: number,
        searchText: string
    ) => {
        const response = await fetch(
            `${webApi}/call/wizklub_agent_hourly_report/?page=${page}&page_size=${pageSize}&search=${searchText}`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${jwtToken}`,
                },
                body: JSON.stringify(requestBody),
            }
        );
        if (!response.ok) {
            const errorData = await response.json();
            if (errorData.code === "token_not_valid") {
                navigate("/academic/sri-chaitanya/crm/landing-page");
            }
            throw new Error(errorData.detail || "Failed to fetch user data");
        }
        return await response.json();
    };

    const fetchData = async (
        page: number,
        pageSize: number,
        searchText: string
    ) => {
        setIsLoading(true); // Start loading
        try {
            const [groupsData] = await Promise.all([
                fetchGroupsData(page, pageSize, searchText),
            ]);
            setTotalPages(groupsData.total_pages);
            setAdmin(groupsData.results);
            setTargetDate(groupsData.selected_date);
            setStartHour(groupsData.start_time);
            setEndHour(groupsData.end_time);
            setTeamType(groupsData.team_type);
            setTotalCount(groupsData.total_count);
            setFrom(groupsData.from);
            setTo(groupsData.to);
            setTotalCount(groupsData.total_count);
            // setToastMessage(groupsData.message || "submitted successfully!");
            setShowSuccessToast(true);
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setIsLoading(false); // Stop loading
        }
    };

    const handleTableChange = (pagination: any) => {
        const { current, pageSize } = pagination;
        setCurrentPage(current);
        setPageSize(pageSize);
        fetchData(current, pageSize, searchText); // Fetch new data based on the updated pagination
    };

    const handleSearch = (value: string) => {
        setSearchText(value);
        fetchData(currentPage, pageSize, value);
    };

    const updateBranchDetails = async (
        id: any,
        updateData: { [x: number]: any }
    ) => {
        const requestOptions = {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${jwtToken}`,
            },
            body: JSON.stringify(updateData),
        };
        const url = `${webApi}/branches/branch_details/${id}/`;
        const response = await fetch(url, requestOptions);
        if (!response.ok) {
            const errorData = await response.json();
            throw new Error("Network response was not ok");
        }
    };

    const handleCheckboxChange = async (
        id: any,
        field: string,
        value: boolean
    ) => {
        const updateData = { [field]: value };
        try {
            await updateBranchDetails(id, updateData);
            await fetchData(currentPage, pageSize, searchText);
        } catch (error) {
            console.error("Error updating branch details:", error);
        }
    };

    const handleSelect = (
        student_id: any,
        selectedRowKeys: string[],
        setSelectedRowKeys: React.Dispatch<React.SetStateAction<string[]>>
    ) => {
        const selectedIds = [...selectedRowKeys];
        const index = selectedIds.indexOf(student_id);
        if (index >= 0) {
            selectedIds.splice(index, 1);
        } else {
            selectedIds.push(student_id);
        }
        setSelectedRowKeys(selectedIds);
    };

    const handleSelectAll = (
        e: CheckboxChangeEvent,
        data: { id: any }[],
        setSelectedRowKeys: React.Dispatch<React.SetStateAction<string[]>>
    ) => {
        if (e.target.checked) {
            const allIds = data.map((item) => item.id);
            setSelectedRowKeys(allIds);
        } else {
            setSelectedRowKeys([]);
        }
    };

    const handleSelectHour = async (e: { preventDefault: () => void }) => {
        e.preventDefault();
        setAgentsLoading(true);
        try {

            const response = await fetch(
                `${webApi}/call/wizklub_agent_hourly_report/`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${jwtToken}`,
                    },
                    body: JSON.stringify(requestBody),
                }
            );

            const data = await response.json();
            if (!response.ok) {
                setDangerToastMessage(data.error);
                setShowSolidDangerToast(true);
                setTimeout(() => setShowSolidDangerToast(false), 3000);
                throw new Error("Failed to assign agent");
            }

            console.log("Agent assigned successfully", data);
            setToastMessage(data.message);
            setshowSolidSuccessToast(true);
            setSelectedRowKeys([]);
            setSelectedAgent([]);
            // setTargetDate("");
            // setAdmin(data.results);
            setAsignShowCard(false);
            fetchData(
                currentPage,
                pageSize,
                searchText,
            );
            // setTargetDate("");
            // setStartHour(null);
            // setEndHour(null);
        } catch (error) {
            console.error("Failed to assign agent", error);
        } finally {
            setAgentsLoading(false);
        }
    };

    const handleReset = async () => {
        setStartHour(null);
        setEndHour(null);
        setTargetDate("");
        setTeamType("");
        localStorage.removeItem("wizklubTeamType");
        localStorage.removeItem("wizklubStartHour");
        localStorage.removeItem("wizklubEndHour");
        localStorage.removeItem("wizklubTargetDate");
        setIsLoading(true);

        try {
            const response = await fetch(
                `${webApi}/call/wizklub_agent_hourly_report/`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${jwtToken}`,
                    },
                    body: JSON.stringify({}), // Empty body
                }
            );

            const groupsData = await response.json();

            if (!response.ok) {
                throw new Error(groupsData.error || "Failed");
            }

            setTotalPages(groupsData.total_pages);
            setAdmin(groupsData.results);
            setTargetDate(groupsData.selected_date);
            setStartHour(groupsData.start_time);
            setEndHour(groupsData.end_time);
            setTeamType(groupsData.team_type);
            setTotalCount(groupsData.total_count);
            setFrom(groupsData.from);
            setTo(groupsData.to);
            setTotalCount(groupsData.total_count);
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleSelectChange = (value: string[]) => {
        setSelectedAgent(value);
    };

    const [loading, setLoading] = useState(false);

    const handleExportClick = async () => {

        let apiUrl = `${webApi}/exports/export_wizklub_hourly_report/?token=${jwtToken}`;
        if (targetDate) apiUrl += `&target_date=${targetDate}`;
        if (startHour) apiUrl += `&start_time=${startHour}`;
        if (endHour) apiUrl += `&end_time=${endHour}`;
        if (teamType) apiUrl += `&team_type=${teamType}`;
        if (searchText) apiUrl += `&search=${searchText}`

        window.location.href = apiUrl

    };

    const columns = [
        // {
        //     title: "Action",
        //     dataIndex: "action",
        //     render: (_text: any, record: { id: any }) => (
        //         <Checkbox
        //             checked={selectedRowKeys.includes(record.id)}
        //             onChange={() =>
        //                 handleSelect(record.id, selectedRowKeys, setSelectedRowKeys)
        //             }
        //         />
        //     ),
        //     key: "action",
        //     // align: "center",
        // },
        {
            title: "Name",
            dataIndex: "username",
        },
        {
            title: "Team Type",
            dataIndex: "team_type"
        },
        {
            title: "Total Calls",
            dataIndex: "total_calls",
        },
        {
            title: "Connected Calls",
            dataIndex: "connected_calls",
        },
        {
            title: "Conversation Duration",
            dataIndex: "total_conversation_duration",
        },
        {
            title: "Sales",
            dataIndex: "sales",
        },

        // checkPermission("can_assign_wizklub_branch_detailes", "custom_model") ? {
        //   title: "Is Wizklub",
        //   dataIndex: "is_wizklub",
        //   render: (
        //     text: any,
        //     record: { id: any; is_wizklub: boolean | undefined }
        //   ) => (
        //     <input
        //       type="checkbox"
        //       name={`wizklub_${record.id}`}
        //       checked={record.is_wizklub}
        //       onChange={() =>
        //         handleCheckboxChange(record.id, "is_wizklub", !record.is_wizklub)
        //       }
        //     />
        //   ),
        // }: {},,

        // {
        //   title: "Is SummerCamp Lead",
        //   dataIndex: "is_summercamp_lead",
        //   render: (
        //     text: any,
        //     record: { id: any; is_summercamp_lead: boolean | undefined }
        //   ) => (
        //     <input
        //       type="checkbox"
        //       name={`wizklub_${record.id}`}
        //       checked={record.is_summercamp_lead}
        //       onChange={() =>
        //         handleCheckboxChange(record.id, "is_summercamp_lead", !record.is_summercamp_lead)
        //       }
        //     />
        //   ),
        // },

        // {
        //   title: "Is Offline",
        //   dataIndex: "is_offline",
        //   render: (text: any, record: { id: any; is_offline: boolean | undefined; }) => (
        //     <input
        //       type="checkbox"
        //       name={`offline_${record.id}`}
        //       checked={record.is_offline}
        //       onChange={() => handleCheckboxChange(record.id, 'is_offline', !record.is_offline)}
        //     />
        //   ),
        // },

    ];


    return (
        <div>
            <div className="page-wrapper">
                <div className="content">
                    {/* Page Header */}
                    <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
                        <div className="my-auto mb-2">
                            <h3 className="page-title mb-1">Wizklub Hour Report</h3>
                            <nav>
                                <ol className="breadcrumb mb-0">
                                    <li className="breadcrumb-item">
                                        <Link to={routes.adminDashboard1}>Dashboard</Link>
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">
                                        Wizklub Hour Report
                                    </li>
                                </ol>
                            </nav>
                        </div>
                        <div className="d-flex align-items-center flex-wrap gap-3">


                            <button
                                className="btn btn-primary"
                                onClick={handleExportClick}
                                disabled={loading}
                            >
                                Export
                            </button>

                        </div>
                    </div>
                    {/* /Page Header */}
                    {/* Guardians List */}
                    <div
                        className="card "
                        style={{
                            width: "100%",
                            boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
                            borderRadius: "10px",
                        }}
                    >
                        <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
                            <h4 className="mb-3">Wizklub Hour Report</h4>
                            <div className="d-flex align-items-end flex-wrap ms-auto gap-2 me-1 pb-3">



                                {targetDate && (
                                    <OverlayTrigger placement="top"
                                        overlay={
                                            <Tooltip id="tooltip-top">Date</Tooltip>
                                        }>
                                        <div
                                            className="px-3 py-2 rounded-pill"
                                            style={{
                                                background: "#E8F4FD",
                                                border: "1px solid #BFDBFE"
                                            }}
                                        >
                                            📅 <strong>{targetDate}</strong>
                                        </div>
                                    </OverlayTrigger>
                                )}

                                {startHour && endHour && (
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={
                                            <Tooltip id="tooltip-top">
                                                Time Range
                                            </Tooltip>
                                        }
                                    >
                                        <div
                                            className="px-3 py-2 rounded-pill"
                                            style={{
                                                background: "#EAFBF3",
                                                border: "1px solid #BBF7D0",
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "8px",
                                            }}
                                        >
                                            🕒 <strong>{startHour}</strong>
                                            <span className="text-muted">-</span>
                                            <strong>{endHour}</strong>
                                        </div>
                                    </OverlayTrigger>
                                )}
                                {teamType && (
                                    <OverlayTrigger placement="top"
                                        overlay={
                                            <Tooltip id="tooltip-top">Team Type</Tooltip>
                                        }>
                                        <div
                                            className="px-3 py-2 rounded-pill"
                                            style={{
                                                background: "#F3E8FF",
                                                border: "1px solid #E9D5FF"
                                            }}
                                        >
                                            🏢 <strong>{teamType}</strong>
                                        </div>
                                    </OverlayTrigger>
                                )}
                                {/* Save Button */}
                                <button
                                    className="btn btn-primary"
                                    onClick={() => setAsignShowCard(true)}
                                >
                                    Select Hour
                                </button>

                                {/* Reset Button */}
                                <button
                                    className="btn btn-primary"
                                    onClick={handleReset}
                                >
                                    Reset
                                </button>
                            </div>
                        </div>
                        <div className="card-body p-0 py-3">
                            {/* <div
                                className="serch-global text-right"
                                style={{ marginRight: "15px" }}
                            >
                                <input
                                    type="search"
                                    className="form-control form-control-sm mb-3 w-auto float-end"
                                    value={searchText}
                                    placeholder="Search"
                                    onChange={(e) => handleSearch(e.target.value)}
                                    aria-controls="DataTables_Table_0"
                                ></input>
                            </div> */}
                            {isLoading ? (
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "flex-start",
                                        height: "100vh",
                                        paddingTop: "20px",
                                    }}
                                >
                                    <Spin /> {/* Display loader while loading */}
                                </div>
                            ) : (
                                <Table
                                    columns={columns}
                                    dataSource={admin}
                                    Selection={false}
                                    pagination={{
                                        current: currentPage,
                                        pageSize: pageSize,
                                        locale: { items_per_page: "" },
                                        nextIcon: <span>Next</span>,
                                        prevIcon: <span>Prev</span>,
                                        defaultPageSize: 10,
                                        showSizeChanger: true,
                                        total: totalCount,
                                        showTotal: (total: any, range: any[]) =>
                                            `${range[0]}-${range[1]} of ${total}`,
                                        pageSizeOptions: ["10", "20", "100"],
                                    }}
                                    onChange={handleTableChange} // Move this outside of pagination
                                    onSearch={handleSearch}
                                    searchText={searchText}
                                />
                            )}
                        </div>
                    </div>
                    {/* /Guardians List */}
                </div>
            </div>

            {
                AsignshowCard && (
                    <>
                        <div
                            style={{
                                position: "fixed",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                backgroundColor: "rgba(0,0,0,0.5)",
                                zIndex: 1049,
                            }}
                        />
                        <div
                            className="card"
                            style={{
                                position: "fixed",
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                                width: "20%",
                                boxShadow: "0 12px 24px rgba(0,0,0,0.15)",
                                borderRadius: "10px",
                                zIndex: 1050,
                                backgroundColor: "#f9f9f9",
                                padding: "20px",
                            }}
                        >
                            <form onSubmit={handleSelectHour}>
                                <div className="modal-body">
                                    <div className="row">
                                        <div className="col-md-12">

                                            {/* Select Date */}
                                            <div className="mb-3">
                                                <label
                                                    className="form-label"
                                                    style={{
                                                        paddingBottom: "10px",
                                                        fontWeight: "bold",
                                                        color: "#555",
                                                    }}
                                                >
                                                    Target Date
                                                </label>
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    value={targetDate}
                                                    onChange={(e) => {
                                                        setTargetDate(e.target.value);
                                                        setTargetDate1(e.target.value);
                                                    }}
                                                    required
                                                />
                                            </div>

                                            {/* Select Start Hour */}
                                            <div className="mb-3">
                                                <label
                                                    className="form-label"
                                                    style={{
                                                        paddingBottom: "10px",
                                                        fontWeight: "bold",
                                                        color: "#555",
                                                    }}
                                                >
                                                    Start Hour
                                                </label>
                                                <Select
                                                    value={startHour}
                                                    onChange={(value) => {
                                                        setStartHour(value);
                                                        setStartHour1(value);
                                                    }}
                                                    style={{ width: "100%" }}
                                                    placeholder="Select Start Hour"
                                                >
                                                    {Array.from({ length: 24 }, (_, index) => {
                                                        const hour12 = index % 12 || 12;
                                                        const period = index < 12 ? "AM" : "PM";
                                                        const time = `${hour12}:00 ${period}`;

                                                        return (
                                                            <Option key={index} value={time}>
                                                                {time}
                                                            </Option>
                                                        );
                                                    })}
                                                </Select>
                                            </div>

                                            {/* Select End Hour */}
                                            <div className="mb-3">
                                                <label
                                                    className="form-label"
                                                    style={{
                                                        paddingBottom: "10px",
                                                        fontWeight: "bold",
                                                        color: "#555",
                                                    }}
                                                >
                                                    End Hour
                                                </label>
                                                <Select
                                                    value={endHour}
                                                    onChange={(value) => {
                                                        setEndHour(value);
                                                        setEndHour1(value);
                                                    }}
                                                    style={{ width: "100%" }}
                                                    placeholder="Select End Hour"
                                                >
                                                    {Array.from({ length: 24 }, (_, index) => {
                                                        const hour12 = index % 12 || 12;
                                                        const period = index < 12 ? "AM" : "PM";
                                                        const time = `${hour12}:00 ${period}`;

                                                        return (
                                                            <Option key={index} value={time}>
                                                                {time}
                                                            </Option>
                                                        );
                                                    })}
                                                </Select>
                                            </div>
                                            <div className="mb-3">
                                                <label
                                                    className="form-label"
                                                    style={{
                                                        paddingBottom: "10px",
                                                        fontWeight: "bold",
                                                        color: "#555",
                                                    }}
                                                >
                                                    Team Type
                                                </label>

                                                <Select
                                                    value={teamType}
                                                    onChange={(value) => setTeamType(value)}
                                                    style={{ width: "100%" }}
                                                    placeholder="Select Team Type"
                                                >
                                                    <Option value="All">All</Option>
                                                    <Option value="Hyderabad">Hyderabad</Option>
                                                    <Option value="Bengaluru">Bengaluru</Option>
                                                </Select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    {/* <Button
                                    className="btn btn-light me-2"
                                    onClick={() => setAsignShowCard(false)}
                                >
                                    Cancel
                                </Button> */}
                                    <button
                                        className="btn btn-primary"
                                        type="submit"
                                        disabled={agentsLoading}
                                    >
                                        Save Changes
                                    </button>
                                </div>
                            </form>
                        </div>
                    </>
                )
            }
            <>
                {/* Delete Modal */}
                <div className="modal fade" id="delete-modal">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <form>
                                <div className="modal-body text-center">
                                    <span className="delete-icon">
                                        <i className="ti ti-trash-x" />
                                    </span>
                                    <h4>Confirm Deletion</h4>
                                    <p>
                                        You want to delete all the marked items, this cant be undone
                                        once you delete.
                                    </p>
                                    <div className="d-flex justify-content-center">
                                        <Link
                                            to="#"
                                            className="btn btn-light me-3"
                                            data-bs-dismiss="modal"
                                        >
                                            Cancel
                                        </Link>
                                        <Link
                                            to="#"
                                            data-bs-dismiss="modal"
                                            className="btn btn-danger"
                                        >
                                            Yes, Delete
                                        </Link>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <Toast
                    show={showSolidDangerToast}
                    onClose={handleSolidDangerToastClose}
                    id="solidDangerToast"
                    className="colored-toast bg-danger text-fixed-white"
                    role="alert"
                    aria-live="assertive"
                    aria-atomic="true"
                    style={{
                        position: "fixed",
                        top: "20px",
                        right: "20px",
                        zIndex: 1050,
                    }}
                >
                    <Toast.Body>{dangerToastMessage}</Toast.Body>
                </Toast>
                {/* /Delete Modal */}
            </>
        </div >
    );
};

export default WizklubHourlyReport;
